import { css } from 'styled-components';

/* Interfaces */
interface IFormFieldsetProps {
    errorMessage?: string;
    disable?: boolean;
}

const FormFieldset = css < IFormFieldsetProps >`
::after {
    font-size: 12px;
    margin-right: 20px;
    color: #E02020;
    padding-top: 8px;
  }

.legoFormInput {
  ${({ errorMessage }) => `
    border: ${errorMessage ? '1px solid #E02020' : '1px solid #ACC2D3'};
    &:focus {
      outline-color: ${errorMessage ? '#E02020' : '#5DC5EA'};
    }
  `}
}

opacity: 1;

${({ disable }) => `

.legoInputHourCustomInput {
  opacity: 1;
}

.legoFormFieldLabel {
  color: ${disable ? '#ACC2D3' : '#4A4A4A'};
}

.legoInputHourIndicator {
  &::after {
    color: ${disable ? '#ACC2D3' : '#657480'};
  }
}

.legoInputHourIconContainer >svg{
  fill:${disable ? '#ACC2D3' : '#8295A3'};
}

`}
`;

export default FormFieldset;
